import { Select, styled } from "@mui/material";

export const Styled = {
    Form: styled("form")`
        padding: 0px 54px;
        display: flex;
        align-items: center;
        flex: 1;
        ${props => props.theme.breakpoints.down("sm")} {
            padding: 0px 14px;
        }
        ${props => props.theme.breakpoints.down("xs")} {
            padding: 0px;
        }
    `,
    CountrySelector: styled(Select)`
        .MuiSelect-select {
            display: flex;
            align-items: center;
        }
    `,
};
